/*
 * Levendi — scroll reveal for the shared editorial page system.
 *
 * Content is visible by default. The section opts into motion synchronously
 * (see snippets/levendi-page-boot.liquid) by adding .lv-motion to its root, so
 * a JS failure, a blocked asset or prefers-reduced-motion all leave the page
 * fully readable and static rather than blank.
 */
(function () {
  'use strict';

  function init(root) {
    if (!root || !root.classList.contains('lv-motion')) return;
    if (root.dataset.lvReveal === 'on') return;
    root.dataset.lvReveal = 'on';

    var items = root.querySelectorAll('.lv-rv');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      reveal(items);
      return;
    }

    var reported = false;
    var observer = new IntersectionObserver(
      function (entries) {
        reported = true;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -30px 0px' }
    );

    items.forEach(function (item) {
      observer.observe(item);
    });

    /* Fail-open: a working observer reports on the first frame. If nothing is
       reported the environment isn't compositing, so show everything. */
    window.setTimeout(function () {
      if (reported) return;
      observer.disconnect();
      reveal(items);
    }, 2000);
  }

  function reveal(items) {
    items.forEach(function (item) {
      item.classList.add('is-in');
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('.lv-page').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  /* On templates with the slim utility bar, filter changes NAVIGATE instead
     of AJAX-morphing. The theme's facets JS re-renders the grid section with
     a view transition + skeleton, and on these templates that morph corrupts
     the custom header/bar DOM (stuck skeleton, missing controls). The theme
     still pushes the filtered URL synchronously on change — we simply land
     on it with a clean server render, same as the sort dropdown does. */
  (function () {
    if (!document.querySelector('.lv-ubar')) return;
    var reloading = false;

    function scheduleReload() {
      if (reloading) return;
      reloading = true;
      /* pushState of the new filter URL happens synchronously in the same
         change handler; one tick later the URL is the filtered one. */
      setTimeout(function () {
        window.location.reload();
      }, 60);
    }

    document.addEventListener(
      'change',
      function (e) {
        if (e.target && e.target.closest && e.target.closest('#filters-drawer')) {
          scheduleReload();
        }
      },
      true
    );

    /* "Clear" / "Clear all" are clicks, not input changes. */
    document.addEventListener(
      'click',
      function (e) {
        if (!e.target || !e.target.closest) return;
        var btn = e.target.closest('#filters-drawer button[on\\:click], .facets__status button');
        if (!btn) return;
        var action = btn.getAttribute('on:click') || '';
        if (action.toLowerCase().indexOf('clear') >= 0) scheduleReload();
      },
      true
    );
  })();

  /* Theme editor re-renders sections in place. */
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

})();
